
const Propriedades = {
  text: 'Propriedades rurais',
  link: '/minhas-propriedades',
  icon: 'icon-home'
};

const Backup = {
  text: 'Backup',
  link: '/contador/backup',
  icon: 'fas fa-download'
};

const DocumentosFiscais = {
  text: 'Monitor Fiscal',
  link: '/monitor-fiscal',
  icon: 'fas fa-barcode',
  parentAsTarget: true,
  submenu: [
    {
      text: 'Download via Chave',
      link: '/monitor-fiscal/chave-acesso',
      icon: 'fas fa-key'
    }
  ]
};

const Conciliacao = {
  text: 'Conciliação',
  link: '/conciliacao-bancaria',
  icon: 'fas fa-university',

}

const Financeiro = {
  text: 'Escrituração',
  link: '/escrituracao',
  icon: 'fas fa-money-check-alt',
};

const Automacoes = {
  text: 'Automações',
  link: '/automacoes',
  icon: 'fas fa-robot',
  alert: 'NOVO!'
};

const RelatorioAcessos = {
  text: 'Relatorio de acessos',
  link: '/contador/relatorio-de-acessos',
  icon: 'fas fa-book-open',
};

const FolhaEsocial = {
  text: 'E-Social',
  link: '/e-social',
  icon: 'img-assets/img/esocial_white.png',
  alert: 'NOVO!'
}


const Relatorios = {
  text: 'Relatórios',
  link: '#',
  icon: 'fas fa-chart-area',
  submenu: [
    {
      text: 'Consolidação Mensal',
      link: '/relatorios/consolidacao-mensal',
      icon: 'far fa-chart-bar'
    },
    {
      text: 'Livro Diário',
      link: '/relatorios/livro-caixa',
      icon: 'fas fa-book-open'
    },
    {
      text: 'Livro Razão',
      link: '/relatorios/livro-razao',
      icon: 'fas fa-book'
    },
    {
      text: 'Análise por Participante',
      link: '/relatorios/analise-participante',
      icon: 'fas fa-user-tie',
    },
    {
      text: 'Estoque Geral',
      link: '/relatorios/relatorio-estoque',
      icon: 'fas fa-box-open',
    },
    {
      text: 'Comparativo',
      link: '/relatorios/comparativo-anual',
      icon: 'fas fa-balance-scale',
    },
  ]
};

const Cadastros = {
  text: 'Cadastros',
  link: '#',
  icon: 'fas fa-address-book',
  submenu: [
    {
      text: 'Agrupadores',
      link: '/cadastros/agrupadores',
      icon: 'fas fa-tag'
    },
    {
      text: 'Participantes',
      link: '/cadastros/participantes',
      icon: 'fas fa-users'
    },
    {
      text: 'Pastas',
      link: '/cadastros/pastas',
      icon: 'far fa-folder'
    },
    {
      text: 'Plano de contas',
      link: '/cadastros/plano-de-contas',
      icon: 'fas fa-align-left'
    },
    {
      text: 'Históricos',
      link: '/cadastros/historicos',
      icon: 'fas fa-quote-left'
    },
    {
      text: 'Produtos',
      link: '/cadastros/produtos',
      icon: 'fas fa-box',
    },
    {
      text: 'Exportações',
      link: '/cadastros/exportacoes',
      icon: 'fas fa-file-export',
    },
    {
      text: 'Arquivos',
      link: '/cadastros/enviar-arquivos',
      icon: 'fas fa-file',
    }
  ]
};

const Cobrancas = {
  text: 'Financeiro',
  link: '/contador/cobrancas',
  icon: 'fas fa-wallet',
}

// contador
const Reintegrar = {
  text: 'Reintegrar DF-e',
  link: '/reintegrar',
  icon: 'fas fa-sync-alt'
};

const Empresas = {
  text: 'Empresas',
  link: '/contador/empresas',
  icon: 'fas fa-building'
};

const Colaboradores = {
  text: 'Colaboradores',
  link: '/contador/colaboradores',
  icon: 'fas fa-users'
};

const MinhaConta = {
  text: 'Minha Conta',
  link: '/contador/minha-conta',
  icon: 'fas fa-user-cog'
};

const NovoCliente = {
  text: 'Novo cliente',
  link: '/contador/novo-cliente',
  icon: 'fas fa-user-plus'
};
const EditarUser = {
  text: 'Editar office',
  link: '/contador/edicao-user',
  icon: 'fas fa-user-plus'
};

const SuperUser = {
  text: 'Superusuário',
  link: '/contador/superuser',
  icon: 'fas fa-user-shield'
};

const RelatoriosGerenciais = {
  text: 'Relatórios Gerenciais',
  link: '#',
  icon: 'fas fa-chart-bar',
  submenu: [
    {
      text: 'Certificados',
      link: '/contador/certificados',
      icon: 'fas fa-certificate'
    },
    {
      text: 'Lançamentos',
      link: '/contador/analise-gerencial',
      icon: 'fas fa-file-invoice-dollar',

    },
    {
      text: 'Imóveis',
      link: '/contador/relatorio-empresa',
      icon: 'fas fa-store-alt',

    },
    {
      text: 'Produtores',
      link: '/contador/relatorio-produtores',
      icon: 'fas fa-address-card',
    },
  ]
};

// consultor

const RelatoriosConsultor = {
  text: 'Relatórios',
  link: '#',
  icon: 'fas fa-chart-area',
  submenu: [
    {
      text: 'Consolidação Mensal',
      link: '/consultor/consolidacao-mensal',
      icon: 'far fa-chart-bar'
    },
    {
      text: 'Livro Diário',
      link: '/consultor/livro-caixa',
      icon: 'fas fa-book-open'
    },
    {
      text: 'Livro Razão',
      link: '/consultor/livro-razao',
      icon: 'fas fa-book'
    },
    {
      text: 'Análise por Participante',
      link: '/consultor/analise-participante',
      icon: 'fas fa-user-tie',

    },
    {
      text: 'Estoque Geral',
      link: '/relatorios/relatorio-estoque',
      icon: 'fas fa-box-open',

    }
  ]
};

const EnviarArquivosConsultor = {
  text: 'Arquivos',
  link: '/enviar-arquivos-consultor',
  icon: 'fas fa-file',

}

const Escrituracao = {
  text: 'Escrituração',
  link: '/escrituracao-consultor',
  icon: 'fas fa-money-check-alt',
};

const DocumentosFiscaisConsultor = {
  text: 'Monitor Fiscal',
  link: '/monitor-fiscal-consultor',
  icon: 'fas fa-barcode',
};

const ConciliacaoConsultor = {
  text: 'Conciliação',
  link: '/conciliacao-consultor',
  icon: 'fas fa-university',

};

const IRPF = {
  text: 'IRPF',
  link: '/irpf',
  icon: 'fas fa-file-invoice-dollar',
  submenu: [
    {
      text: 'LCA',
      link: '/livro-caixa/lca',
      icon: 'fas fa-scroll'
    },
    {
      text: 'LCDPR',
      link: '/livro-caixa/lcdpr',
      icon: 'fas fa-book'
    },
    {
      text: 'Estoque',
      link: '/livro-caixa/estoque',
      icon: 'fas fa-boxes',

    },
    {
      text: 'Bens',
      link: '/livro-caixa/bens',
      icon: 'fas fa-house-damage',
    },
    {
      text: 'Financiamentos',
      link: '/livro-caixa/financiamentos',
      icon: 'fas fa-window-restore',
    },
    {
      text: 'Simulador de IR',
      link: '/livro-caixa/simulador-ir',
      icon: 'fas fa-calculator',
    },
  ]
}

export const menu = [
  // Painel,
  Propriedades,
  DocumentosFiscais,
  Financeiro,
  Conciliacao,
  IRPF,
  Relatorios,
  Cadastros,
  Automacoes,
  FolhaEsocial,
];

export const menuSimple = [
  Propriedades,
  DocumentosFiscais,
  Financeiro,
]

export const menuAnalogico = [
  Propriedades,
  DocumentosFiscais,
  Conciliacao,
  IRPF,
  Financeiro,
  Relatorios,
  Cadastros
];


export const menuContador = [
  Empresas,
  RelatoriosGerenciais,
  Colaboradores,
  MinhaConta,
  Cobrancas,
];

export const menuContadorSimple = [
  Empresas,
  Cobrancas
];

export const menuContadorFuncionario = [
  Empresas,
  MinhaConta
];

export const menuContadorFuncionarioSimple = [
  Empresas,
];

export const menuSuper = [
  Empresas,
  RelatoriosGerenciais,
  Colaboradores,
  MinhaConta,
  NovoCliente,
  SuperUser,
  EditarUser,
  Reintegrar,
  Cobrancas,
  RelatorioAcessos,
];

export const menuConsultor = [
  DocumentosFiscaisConsultor,
  Escrituracao,
  ConciliacaoConsultor,
  RelatoriosConsultor,
  EnviarArquivosConsultor,
];
